import useItem, { itemConfigs } from '../../../tableV2/hooks/common/useItem'
import useItemTrend, {
  itemTrendConfigs,
} from '../../../tableV2/hooks/common/useItemTrend'
import useItemWithoutTotal from '../../../tableV2/hooks/common/useItemWithoutTotal'
import { api as deliveryApi, configs as deliveryConfigs } from './delivery'
import useLocationDayPartPie, {
  locationDayPartPieConfigs,
} from './useLocationDayPartPie'
import useTrendLocationGroupDiscount, {
  trendLocationGroupDiscountConfigs,
} from './useTrendLocationGroupDiscounts'
import useTrendLocationGroupFinancialKpis, {
  trendLocationGroupFinancialKpisConfigs,
} from './useTrendLocationGroupFinancialKpis'
import useTrendLocationGroupLossPreventions, {
  trendLocationGroupLossPreventionConfigs,
} from './useTrendLocationGroupLossPreventions'
import useTrendLocationRevenueCenterSales, {
  trendLocationRevenueCenterSalesConfigs,
} from './useTrendLocationRevenueCenterSales'

export const configs = {
  ...deliveryConfigs,
  trendLocationGroupFinancialKpis: trendLocationGroupFinancialKpisConfigs,
  trendLocationGroupDiscount: trendLocationGroupDiscountConfigs,
  trendLocationGroupLossPrevention: trendLocationGroupLossPreventionConfigs,
  locationDayPartPie: locationDayPartPieConfigs,
  trendLocationRevenueCenterSales: trendLocationRevenueCenterSalesConfigs,
  item: itemConfigs,
  itemWithoutTotal: itemConfigs,
  itemTrend: itemTrendConfigs,
}

export const api = {
  ...deliveryApi,
  trendLocationGroupFinancialKpis: useTrendLocationGroupFinancialKpis,
  trendLocationGroupDiscount: useTrendLocationGroupDiscount,
  trendLocationGroupLossPrevention: useTrendLocationGroupLossPreventions,
  locationDayPartPie: useLocationDayPartPie,
  trendLocationRevenueCenterSales: useTrendLocationRevenueCenterSales,
  item: useItem,
  itemWithoutTotal: useItemWithoutTotal,
  itemTrend: useItemTrend,
}
